import { lazy, Suspense, useCallback, useMemo, useState, type ReactNode } from "react";
import { useSidePanel } from "@/components/patterns";
import { PainelDoCandidatoContext, type AbrirCandidato } from "./painel-do-candidato";
import type { CandidatoPanelTab } from "./CandidatoPanel";

const CandidatoPanel = lazy(() => import("./CandidatoPanel").then((module) => ({ default: module.CandidatoPanel })));

/**
 * Painel do candidato das telas que não montam o seu (avaliações, atividades,
 * recomendações, copiloto): o LinkedIn de qualquer card abre aqui. Usa outro nome na
 * URL (?painel=perfil) para não disputar com o painel de uma página.
 */
export function CandidatoPanelGlobal({ children }: { children: ReactNode }) {
  const painel = useSidePanel<CandidatoPanelTab>("perfil");
  const [paginas, setPaginas] = useState<AbrirCandidato[]>([]);

  const registrar = useCallback((abrir: AbrirCandidato) => {
    setPaginas((atuais) => [...atuais, abrir]);
    return () => setPaginas((atuais) => atuais.filter((registrado) => registrado !== abrir));
  }, []);

  const abrirDaPagina = paginas[paginas.length - 1];
  const value = useMemo(() => ({ abrir: abrirDaPagina ?? painel.open, registrar }), [abrirDaPagina, painel.open, registrar]);

  return (
    <PainelDoCandidatoContext.Provider value={value}>
      {children}
      {painel.itemId && (
        <Suspense fallback={null}>
          <CandidatoPanel freelancerId={painel.itemId} tab={painel.tab} onTabChange={painel.setTab} onClose={painel.close} />
        </Suspense>
      )}
    </PainelDoCandidatoContext.Provider>
  );
}
